import { Injectable } from '@angular/core';
//import { User } from '../../models/AnnualRequirement/Annual-Requirement';
import { global } from '../../models/global';
import { Observable } from 'rxjs/Observable';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class AnnualRequirementService {
  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  DownloadExcel(userId: string,AnnualCycle:string, region:string, rolecode:string, year:any): Observable<any> {
    //let m_userid = { 'userId': userId };    
    let url = this.ROOT_URL + '/api/AnnualRequirement/DownloadExcel';
    let body = { "userId": userId,"AnnualCycle":AnnualCycle,"region": region ,"roleCode":rolecode,"Year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  uploadDocument(documents: File, UserId: string, Region:string,AnnualCycle :string): Observable<any> {
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", UserId);
    formData.append("Region", Region);
    formData.append("AnnualCycle", AnnualCycle);
    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/AnnualRequirement/UploadFiles",
      headers: headers,
      body: formData
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  GetAnnualRequirement(AnnualType : any,userid: any, region: any, month: any, product: any, crop: any,year: any, currentpage: any): Observable<any> {
    debugger;
    let url = this.ROOT_URL + '/api/AnnualRequirement/GetAnnualRequirement';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "AnnualCycle" :AnnualType,"userId": userid, "productId": product, "month": month, "region": region, "cropId": crop,"year":year,"PageNo": currentpage };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  FinalSubmission(userid: any, region: any,AnnualCycle :any): Observable<any> {
    let url = this.ROOT_URL + '/api/AnnualRequirement/FinalSubmissionRequest';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "UserId": userid, "Region": region ,"AnnualCycle" :AnnualCycle};
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  getApprovalHistory(AnnualCycle,PageNo:number,userID: string, roleID: string, reqType: string, sbuCode: string,divisionCode: string, zoneCode: string,regionCode: string,rmhCode:string, year:any): Observable<any> {
    let url = this.ROOT_URL + '/api/AnnualRequirement/GetApprovalHistory';
    let body = { "AnnualCycle":AnnualCycle,"PageNo":PageNo,"userID": userID, "roleID": roleID, "reqType": reqType, "sbuCode": sbuCode,"divisionCode": divisionCode,"zoneCode": zoneCode,"regionCode": regionCode,"rmhCode": rmhCode,"year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }
}